// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Vouchers from "./pages/Vouchers";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import Categories from "./pages/Categories";
import MapList from "./pages/MapList";
import Trolleys from "./pages/Trolleys";
import Promotions from "./pages/Promotions";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/products" element={<Products />} />
        <Route path="/vouchers" element={<Vouchers />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/users" element={<Users />} />   
        <Route path="/categories" element={<Categories />} />
        <Route path="/map" element={<MapList />} />
        <Route path="/trolleys" element={<Trolleys />} />
        <Route path="/promotions" element={<Promotions />} />
      </Routes>
    </Router>
  );
}

export default App;
